// A one-way latch for the pageview: once any real episode has produced a `supercast-timeupdate`,
// treat a player as active for the rest of the session. Works identically on web and native since
// both dispatch the same event (see app/components/media/audio_player_controller.js and
// engines/subscriber_v2/app/javascript/controllers/bridge/playback_listener_controller.js).
let hasActivePlayer = false;

window.addEventListener("supercast-timeupdate", (event) => {
  if (event.detail?.itemId) hasActivePlayer = true;
});

export function isPlayerActive() {
  return hasActivePlayer;
}
